import { getYesPrice, isMarketEnded, sortOutcomesByChance } from '@/lib/utils/outcomePrice';
import type { Event } from '../event/models';
import type { SearchPrediction } from './models';

/** Yes-leg price as a whole percent, clamped to 0..100. */
function toPercent(price: number): number {
  return Math.round(Math.max(0, Math.min(1, price)) * 100);
}

export function mapSearchPrediction(event: Event): SearchPrediction {
  const leading = sortOutcomesByChance(event.markets)[0];
  return {
    id: event.id,
    slug: event.slug,
    title: event.title,
    image: event.image || event.icon || null,
    volume: event.volume,
    endDate: event.endDate,
    chance: leading ? toPercent(getYesPrice(leading, isMarketEnded(event))) : null,
    outcome: leading && event.markets.length > 1 ? leading.question : null,
  };
}
